import React from 'react';

export const Popup = (props: any) => {

  return (
    <React.Fragment>
      	{/* Searchbox Popup  */}
			<div className="metaportal_fn_search_closer"></div>
			<div className="metaportal_fn_searchbox">
				<div className="container small">
					<div className="searchbox">
						<input type="text" placeholder="Search here..." />
						<a href="#">
							<img src="svg/loupe.svg" alt="" className="fn__svg" />
						</a>
					</div>
				</div>
			</div>
			{/* !Searchbox Popup  */}

			{/* Wallet Popup  */}
			<div className="metaportal_fn_wallet_closer ready"></div>
			<div className="metaportal_fn_walletbox ready">
				<a href="#" className="fn__closer"><span></span></a>
				<div className="walletbox">

					<div className="title_holder">
						<h3>Connect Wallet</h3>
						<p>Connect with one of our available wallet providers or create a new one.</p>
					</div>

					<div className="list_holder">
						<ul className="metaportal_fn_items">
							<li>
								<div className="item">
									<a href="#"></a>
									<span className="icon">
										<img src="img/wallet/metamask.png" alt="" />
									</span>
									<span className="text">Metamask</span>
								</div>
							</li>
							<li>
								<div className="item">
									<a href="#"></a>
									<span className="icon">
										<img src="img/wallet/coinbase.png" alt="" />
									</span>
									<span className="text">Coinbase</span>
								</div>
							</li>
							<li>
								<div className="item">
									<a href="#"></a>
									<span className="icon">
										<img src="img/wallet/walletconnect.png" alt="" />
									</span>
									<span className="text">WalletConnect</span>
								</div>
							</li>
							<li>
								<div className="item">
									<a href="#"></a>
									<span className="icon">
										<img src="img/wallet/venly.png" alt="" />
									</span>
									<span className="text">Venly</span>
								</div>
							</li>
						</ul>
					</div>

				</div>
			</div>
			{/* !Wallet Popup  */}
    </React.Fragment>
  )


}





